import { combineReducers } from "redux"
import { user } from './userReducer'

const workspaceReducers = combineReducers({
    user,
})

export default workspaceReducers